import { ApolloClient, createHttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";

import { cache, isLoggedInVar } from "./cache";


const httpLink = createHttpLink({
  uri: '/graphql/',
});

const authLink = setContext((neki, { headers }) => {

  const jwt = localStorage.getItem("jwt");

  return {
    headers: {
      ...headers,
      Authorization: jwt ? `Bearer: ${jwt}` : "",
    }
  }
});


const errorLink = onError(({ operation, response, graphQLErrors, networkError, forward }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      if(message === "Expired or invalid token"){
        isLoggedInVar(false)
      }
      return console.log(message)
    });
  if (networkError) console.log(`[Network error]: ${networkError}`);
});



export const client = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    authLink.concat(httpLink)
  ]),
  cache
});
